
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

import { FinancialInvoice } from '@/domains/global/models'
import { toTitleCase } from '@/domains/global/functions/util'

@Component
export default class InvoiceStatusPill extends Vue {
  @Prop({ type: Object as () => FinancialInvoice, required: true })
  readonly invoice!: FinancialInvoice

  get text () {
    return toTitleCase(this.invoice.status)
  }

  get color () {
    switch (this.invoice.status) {
      case 'paid':
        return 'success'
      case 'refunded':
        return 'error'
      default:
        return null
    }
  }
}
